import {QueryClientProvider} from "@tanstack/react-query";


import {Blocks} from './Blocks';
import {CategoryButton} from './CategoryButton';
import { getQueryClient } from '../../../../Infrastructure'
import { ScrollToTopButton, UiProvider } from '../../../Theme';
import {CategoriesProductsStateProvider} from "../../state";

const queryClient = getQueryClient()

export const BlackFriday = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <UiProvider>
            <CategoriesProductsStateProvider>
                <div className={'mt-5 md:mt-10 mb-8'}>
                    <a
                        className={'react-css text-white text-2xl active:text-white focus:text-white decoration-current ' +
                            'rounded bg-main-color hover:bg-main-color focus:bg-main-color p-4'}
                        href={`${window.BASE_URL}home`}>
                        {'Inapoi la pagina principala'}
                    </a>
                </div>
                <div>
                    <div className="flex flex-col gap-6 justify-center items-center w-full">
                        <Blocks/>
                    </div>
                    <div>
                        <CategoryButton/>
                    </div>
                </div>
                <ScrollToTopButton/>
            </CategoriesProductsStateProvider>
            </UiProvider>
        </QueryClientProvider>
    )
};
